module.exports = __webpack_public_path__ + "img/14.6061ad01.jpg";